module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02-xlarge.3ed32ad1.jpg";